var React = require('react');
var ReactNative = require('react-native');

var {
  AppRegistry,
  Text,
  View,
  StyleSheet,
} = ReactNative;

var WebView = require('./wrappers/WebView-wrapper');
var ReUpButton = require('./ReUpButton');
var ReUpText = require('./ReUpText');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKSpinner,
} = MK;

const patchPostMessageJsCode = `(${String(function() {
  var originalPostMessage = window.postMessage;
  var patchedPostMessage = function(message, targetOrigin, transfer) {
    originalPostMessage(message, targetOrigin, transfer)
  };
  patchedPostMessage.toString = function() {
    return String(Object.hasOwnProperty).replace('hasOwnProperty', 'postMessage')
  };
  window.postMessage = patchedPostMessage;
})})();`

var ReUpCreditCardInput = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager: {},
      style: {},
      appManager:null,
      onLoad:()=>{},
      onError:()=>{},
    }
  },

  getInitialState : function()
  {
    return {
    isInError:false,
    }
  },

  componentWillReceiveProps: function(newProps)
  {

  },

  _successCallback: null,
  retrieveCardInfo: function(successCallback, errorCallback)
  {
    this._successCallback = successCallback;
    this._errorCallback = errorCallback;

    if( this._webView.evaluateJavaScript ) this._webView.evaluateJavaScript('retrieveCardInfo();');
    else if( this._webView.injectJavaScript ) this._webView.injectJavaScript('retrieveCardInfo();');
  },

  onLoad: function()
  {
    var thisThing = this;
    setTimeout(()=>
    {
      if( typeof thisThing._webView !== 'undefined' && thisThing._webView != null && typeof thisThing._webView.evaluateJavaScript !== 'undefined' && thisThing._webView.evaluateJavaScript != null ) thisThing._webView.evaluateJavaScript('checkIfLoaded();')
      // else if( thisThing._webView.injectJavaScript ) thisThing._webView.injectJavaScript('checkIfLoaded();')
      else thisThing.didLoadForSure();
    }, 1000);
  },

  didLoadForSure: function()
  {
    this._hasLoaded = true;
    this.props.onLoad();
  },

  renderError: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var stripeElementsURL = appManager.getStripeElementsURL();
    var title = locManager.localizedStringForKey("STRIP_FAIL_ALERT_TITLE");
    var body = locManager.localizedStringForKey("STRIP_FAIL_ALERT_BODY");
    return <View style={{flexDirection:'column', padding:10, justifyContent:'center', alignItems:'center'}}>
      <ReUpText appManager={appManager} isTitle={true} style={{textAlign:'center', marginBottom:8}}>
      {title}
      </ReUpText>
      <ReUpText appManager={appManager} style={{textAlign:'center'}}>
      {body}
      </ReUpText>
    </View>
  },

  _hasLoaded: false,
  hasLoaded: function()
  {
    return this._hasLoaded;
  },

  render: function()
  {
    if( this.state.isInError ) return this.renderError();

    var thisThing = this;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var stripeElementsURL = appManager.getStripeElementsURL();
    console.log("stripeElementsURL",stripeElementsURL)

    return <View style={[this.props.style, {flexDirection:'column'}]}>
      <WebView ref={ref => { this._webView = ref }}
        javaScriptEnabled={true}
        javaScriptEnabledAndroid={true}
        domStorageEnabled={true}
        injectedJavaScript={patchPostMessageJsCode}
        style={{flex:1, alignSelf:'stretch'}}
        source={{uri:stripeElementsURL, baseURL:'/'}}
        onLoad={()=>
        {
          thisThing.onLoad();
        }}
        onMessage={(data) =>
        {
          if( typeof data.body.data === 'undefined' || data.body.data == "error" )
          {
            thisThing._errorCallback();
            return;
          }
          if( typeof data.body.data !== 'undefined' && data.body.data == "Is Loaded" )
          {
            thisThing.didLoadForSure();
            return;
          }
          var cardInfo = {};
          cardInfo.last4 = data.body.data.token.card.last4;
          cardInfo.exp_month = data.body.data.token.card.exp_month;
          cardInfo.exp_year = data.body.data.token.card.exp_year;
          cardInfo.country = data.body.data.token.card.country;
          cardInfo.address_zip = data.body.data.token.card.address_zip;
          cardInfo.cardID = data.body.data.token.card.id;
          cardInfo.cardType = data.body.data.token.card.type;
          cardInfo.token = data.body.data.token.id;
          thisThing._successCallback(cardInfo)
        }}
        domStorageEnabled={true}
        decelerationRate="normal"
        startInLoadingState={true}
        renderLoading={function()
        {
          return <MKSpinner strokeColor={[appManager.getColorForKey("HeaderTitleColor"), appManager.getColorForKey("HeaderColor")]} style={{marginTop:40, alignSelf:'center'}}/>
        }}
        renderError={this.renderError}
        onError={this.props.onError}/>
    </View>
  }
});

module.exports = ReUpCreditCardInput;
